import React from 'react';
import { RatingType } from '../../types';

export type GridDataItem = {
  performance: number;
  potential: number;
  category: string;
  label: string;
  color: string;
};

export const DotLabel: React.FC<{ gridLabel: GridDataItem | undefined }> = ({
  gridLabel,
}) => (
  <div className="tw-flex tw-items-center tw-gap-2">
    <div
      className="tw-w-[10px] tw-h-4 tw-rounded-[3px]"
      style={{ backgroundColor: gridLabel?.color || '#000000' }}
    />
    <span className="tw-text-sm tw-text-gray-900 tw-font-medium">
      {gridLabel?.label || '-'}
    </span>
  </div>
);

const levels = {
  1: 'Low',
  2: 'Moderate',
  3: 'High',
};


export const getRatingColor = (type: RatingType, ratingValue: number): string => {
  if (type === RatingType.PERFORMANCE || type === RatingType.POTENTIAL) {
    switch (ratingValue) {
      case 1:
        return '!tw-bg-[#EF4444]';
      case 2:
        return '!tw-bg-[#FACC15]';
      case 3:
        return '!tw-bg-[#22C55E]';
      default:
        return '!tw-bg-gray-textGray';
    }
  }

  if (type === RatingType.RETENTION_RISK) {
    switch (ratingValue) {
      case 1:
        return '!tw-bg-[#22C55E]';
      case 2:
        return '!tw-bg-[#FACC15]';
      case 3:
        return '!tw-bg-[#EF4444]';
      default:
        return '!tw-bg-gray-textGray';
    }
  }

  return 'tw-text-gray-textGray';
};

export const Tag: React.FC<{ level: number, type: RatingType }> = ({ level, type }) => {
  return (
    <span
      className={`tw-inline-flex tw-items-center tw-h-6 tw-rounded-full 
         tw-px-2 tw-text-xs tw-font-medium tw-text-white ${getRatingColor(type, level)}`}
    >
      {levels[level as keyof typeof levels]}
    </span>
  );
};

